module.exports = __webpack_public_path__ + "static/media/trainerOne.7c2ab25d.jpg";